import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import AzureLogin from "./views/pages/azureLogin";
import AdminLayout from "./layouts/admin";
import ProtectedRoute from "./routes/privateRoute";
import { handleRedirectCallback } from "./views/pages/azureLogin/authUtility";
import { message } from "antd";
import { useAntiClickjack } from "./globals/hooks/useAntiClickjack";

const App = () => {
  const [isInitializing, setIsInitializing] = useState(true);
  const history = useHistory();
  useEffect(() => {
    const initializeAuth = async () => {
      try {
        const token = await handleRedirectCallback();
        if (token) {
          history.push("/admin/registered-users");
        }
      } catch (error) {
        message.error("Error handling redirect:", error);
      } finally {
        setIsInitializing(false); // Finish initialization
      }
    };

    initializeAuth();
  }, []);

  const { isFramed } = useAntiClickjack();
  if (isFramed) return null;

  if (isInitializing) {
    return <div>Loading...</div>;
  }

  return (
    <Switch>
      {/* Login Route */}
      <Route path="/login" component={AzureLogin} />

      {/* Protected Admin Route */}
      <ProtectedRoute path="/admin" component={AdminLayout} />

      {/* Default Route */}
      <Route path="/">
        <Redirect to="/admin" />
      </Route>
    </Switch>
  );
};

export default App;
